import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick-pnth";
import PrevArrow from "./prevarrow";
import NextArrow from "./nextarrow";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { RTL, VCMS } from "../../global";

const MultiSlider = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [elemms, setElemMs] = useState([]);
  const [elemItemms, setItemMs] = useState([]);
  const [playlistms, setPlaylistMs] = useState(
    VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplayms, setElemDisplayMs] = useState(true);

  useEffect(() => {
    mounted.current = true;
    const ElemDetail = async () => {
      if (mounted.current) {
        setElemMs(props.information);
        if (
          props.information.playlistId !== "" &&
          props.information.playlistId !== null
        ) {
          playlistDetail(
            props.information.playlistId,
            props.information.devices[0].itemSize
          );
        }
        setElemDisplayMs(props.information.devices[0].itemVisibility);
        setItemMs(props.information.items);
      }
    };

    const playlistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      if (VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistMs(result?.data);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(true);
            }
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistMs(result?.data);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(true);
            }
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };
    if (mounted.current) {
      ElemDetail();
      isLoading(false);
    }

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  const settings = {
    centerMode: true,
    centerPadding: "200px",
    slidesToShow: 1,
    slideToScroll: 1,
    rtl: RTL,
    nextArrow: <NextArrow></NextArrow>,
    prevArrow: <PrevArrow></PrevArrow>,
    arrows: true,
    dots: false,
    autoplay: props.information.autoPlay,
    autoplaySpeed: parseInt(props.information.autoPlayTimer),
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 1,
        },
      },
    ],
  };

  if (elemdisplayms && !error && !loading && props.information) {
    return (
      <section className="iq-main-slider p-0 ">
        <Slider className="tvshows-slider p-exist" {...settings}>
          {elemItemms !== null
            ? elemItemms?.map((item, index) =>
                item.itemid.devices[0].itemVisibility ? (
                  <div key={index}>
                    <Anchor
                      to={
                        item.itemid.pageType === "externalPage"
                          ? item.itemid.externalPage
                          : item.itemid.pageType === "internalPage"
                          ? item.itemid.internalPage
                          : item.itemid.pageType === "videoPage"
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.pageType +
                            "/" +
                            item.itemid.videoId
                          : item.itemid.urlName !== ""
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.urlName
                          : item.itemid.pageType + "/" + item.itemid._id
                      }
                    >
                      <div className="shows-img">
                        <LazyImg
                          src={
                            item.itemid.bannerImage
                              ? getAWSUrl() + item.itemid.bannerImage.imagekey
                              : ""
                          }
                          className="w-100"
                          alt=""
                          orient="landscape"
                        />
                        <div className="shows-content">
                          <h4 className="text-white mb-1">{""}</h4>
                          <div className="movie-time d-flex align-items-center">
                            <div className="badge badge-secondary p-1 mr-2">
                              {""}
                            </div>
                            <span className="text-white">{""}</span>
                          </div>
                        </div>
                      </div>
                    </Anchor>
                  </div>
                ) : (
                  ""
                )
              )
            : ""}

          {elemms.playlistId !== null && elemms.playlistId !== undefined
            ? VCMS === "YouTube"
              ? playlistms?.item.map((item, index) => (
                  <div key={index}>
                    <Link
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.contentDetails.videoId
                      }
                    >
                      <div className="shows-img">
                        {/* {item.ContentType==="Premium"?<Icon></Icon>:""}     */}
                        <LazyImg
                          src={
                            "https://i.ytimg.com/vi/" +
                            item.contentDetails.videoId +
                            "/maxresdefault.jpg"
                          }
                          className="w-100"
                          alt=""
                          orient="landscape"
                        />
                        <div className="shows-content">
                          <h4 className="text-white mb-1">{""}</h4>
                          <div className="movie-time d-flex align-items-center">
                            <div className="badge badge-secondary p-1 mr-2">
                              {""}
                            </div>
                            <span className="text-white">{""}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              : playlistms?.playlist.map((item, index) => (
                  <div key={index}>
                    <Link
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.mediaid
                      }
                    >
                      <div className="shows-img">
                        {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                        <LazyImg
                          src={item.image}
                          className="w-100"
                          alt=""
                          orient="landscape"
                        />
                        <div className="shows-content">
                          <h4 className="text-white mb-1">{""}</h4>
                          <div className="movie-time d-flex align-items-center">
                            <div className="badge badge-secondary p-1 mr-2">
                              {""}
                            </div>
                            <span className="text-white">{""}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
            : ""}
        </Slider>
      </section>
    );
  } else if (elemdisplayms && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default MultiSlider;
